(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerIsCover = this.getAttribute('data-sticky-type') === 'cover-logo-size';

      this.headerBounds = {};
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      if (this.headerIsCover) {
        this.header.classList.add('shopify-section-header-cover');
        
        const stickyHeader = document.querySelector('.header-wrapper');
        stickyHeader.classList.add('header-hovered');

        window.addEventListener('scroll', () => {
          let scrollTop =  document.documentElement.scrollTop;

          if (scrollTop > 650) {
            stickyHeader.classList.remove('header-hovered');
          } else {
            stickyHeader.classList.add('header-hovered');
          }
        });

      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      if (this.headerIsCover) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      if (this.headerIsCover) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      if (this.headerIsCover) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => {
				if (disclosure) {
					disclosure.close()
				}
			}
			);
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wallpaper"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('photo-style-showcase')) {
    class PhotoStyleShowcase extends HTMLElement {
      connectedCallback() {
        this.viewer = this.querySelector('[data-viewer]');
        this.beforeImg = this.querySelector('[data-before-img]');
        this.afterImg = this.querySelector('[data-after-img]');
        this.handle = this.querySelector('[data-handle]');
        this.badgeBefore = this.querySelector('[data-badge-before]');
        this.badgeAfter = this.querySelector('[data-badge-after]');
        this.tabs = Array.from(this.querySelectorAll('[data-tab]'));
        this.activeIndex = Math.max(0, this.tabs.findIndex((t) => t.classList.contains('is-active')));
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.reveal = this.dataset.reveal === 'true';
        this.autoplayMs = (parseFloat(this.dataset.autoplay) || 0) * 1000;
 
        this.countEl = this.querySelector('[data-count]');
        this.burstEl = this.querySelector('[data-burst]');
        this.tabs.forEach((t) => this.buildChips(t));
        this.switches = Array.from(this.querySelectorAll('[data-switch]'));
        this.switches.forEach((b) => b.addEventListener('click', () => {
          this.userInteract(); this.activateTab(parseInt(b.dataset.switch, 10));
        }));
 
        this.setPos(50);
        this.bindSlider();
        this.bindGallery();
        this.applyMode(this.tabs[this.activeIndex]);
        this.bindTabs();
        this.bindEditor();
        this.setupAutoplay();
      }
 
      disconnectedCallback() {
        clearTimeout(this.timer);
        clearInterval(this.playTimer);
        cancelAnimationFrame(this.raf);
        if (this.io) this.io.disconnect();
        if (this.onBlockSelect) document.removeEventListener('shopify:block:select', this.onBlockSelect);
      }
 
      /* ---------- Slider ---------- */
      setPos(v) {
        v = Math.max(0, Math.min(100, v));
        this.pos = v;
        this.viewer.style.setProperty('--pos', v + '%');
        if (this.handle) this.handle.setAttribute('aria-valuenow', Math.round(v));
        if (this.badgeBefore) this.badgeBefore.classList.toggle('is-hidden', v < 14);
        if (this.badgeAfter) this.badgeAfter.classList.toggle('is-hidden', v > 86);
      }
 
      bindSlider() {
        const pct = (e) => {
          const r = this.viewer.getBoundingClientRect();
          return ((e.clientX - r.left) / r.width) * 100;
        };
        let state = null;
 
        this.viewer.addEventListener('pointerdown', (e) => {
          if (e.pointerType === 'mouse' && e.button !== 0) return;
          if (this.isGallery()) {
            if (e.target.closest('[data-nav]')) return;
            state = { id: e.pointerId, x: e.clientX, y: e.clientY, gallery: true };
            return;
          }
          state = { id: e.pointerId, x: e.clientX, y: e.clientY, dragging: e.pointerType === 'mouse', moved: false };
          if (state.dragging) {
            e.preventDefault();
            this.userInteract();
            this.viewer.setPointerCapture(e.pointerId);
            this.setPos(pct(e));
          }
        });
 
        this.viewer.addEventListener('pointermove', (e) => {
          if (!state || e.pointerId !== state.id) return;
          if (state.gallery) return;
          if (!state.dragging) {
            const dx = Math.abs(e.clientX - state.x);
            const dy = Math.abs(e.clientY - state.y);
            if (dx > 6 && dx > dy) {
              state.dragging = true;
              this.userInteract();
              try { this.viewer.setPointerCapture(e.pointerId); } catch (_) {}
            } else if (dy > 6) {
              state = null; // vertical scroll – let the page scroll
              return;
            } else {
              return;
            }
          }
          state.moved = true;
          this.setPos(pct(e));
        });
 
        const end = (e) => {
          if (!state || e.pointerId !== state.id) return;
          if (state.gallery) {
            const dx = e.clientX - state.x, dy = e.clientY - state.y;
            if (e.type === 'pointerup' && Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
              this.userInteract();
              this.step(dx < 0 ? 1 : -1);
            }
            state = null;
            return;
          }
          if (e.type === 'pointerup' && !state.dragging && !state.moved) {
            this.userInteract(); // tap on touch screens jumps the divider
            this.setPos(pct(e));
          }
          state = null;
        };
        this.viewer.addEventListener('pointerup', end);
        this.viewer.addEventListener('pointercancel', () => { state = null; });
 
        if (this.handle) {
          this.handle.addEventListener('keydown', (e) => {
            const step = e.shiftKey ? 10 : 5;
            const map = { ArrowLeft: -step, ArrowDown: -step, ArrowRight: step, ArrowUp: step };
            if (e.key in map) this.setPos(this.pos + map[e.key]);
            else if (e.key === 'Home') this.setPos(0);
            else if (e.key === 'End') this.setPos(100);
            else return;
            e.preventDefault();
            this.userInteract();
          });
        }
      }
 
      animatePos(from, to, ms) {
        cancelAnimationFrame(this.raf);
        const t0 = performance.now();
        const ease = (t) => 1 - Math.pow(1 - t, 3);
        const step = (now) => {
          const t = Math.min(1, (now - t0) / ms);
          this.setPos(from + (to - from) * ease(t));
          if (t < 1) this.raf = requestAnimationFrame(step);
        };
        this.raf = requestAnimationFrame(step);
      }
 
 
      /* ---------- Gallery mode ---------- */
      isGallery() { return this.viewer.classList.contains('is-gallery'); }
 
      applyMode(tab) {
        const g = !!tab && tab.dataset.mode === 'gallery';
        this.viewer.classList.toggle('is-gallery', g);
        if (g) this.viewer.tabIndex = 0; else this.viewer.removeAttribute('tabindex');
        if (g) { this.updateCount(tab); this.updateNow(tab); }
        else this.stopPlay();
      }
 
      bindGallery() {
        this.querySelectorAll('[data-nav]').forEach((b) => b.addEventListener('click', (e) => {
          e.stopPropagation(); this.userInteract(); this.step(parseInt(b.dataset.nav, 10));
        }));
        this.querySelectorAll('[data-shuffle]').forEach((b) => b.addEventListener('click', () => { this.userInteract(); this.shuffle(); }));
        this.querySelectorAll('[data-play]').forEach((b) => b.addEventListener('click', () => {
          if (this.playTimer) { this.userInteract(); return; }
          this.stopped = true; clearTimeout(this.timer); this.startPlay(b);
        }));
        this.viewer.addEventListener('keydown', (e) => {
          if (!this.isGallery() || e.target !== this.viewer) return;
          if (e.key === 'ArrowRight') this.step(1);
          else if (e.key === 'ArrowLeft') this.step(-1);
          else return;
          e.preventDefault(); this.userInteract();
        });
      }
 
      galleryButtons(tab) {
        tab = tab || this.tabs[this.activeIndex];
        return tab ? Array.from(tab.querySelectorAll('[data-style]')).filter((b) => !b.hidden) : [];
      }
 
      buildChips(tab) {
        const box = tab.querySelector('[data-chips]'); if (!box) return;
        const seen = new Map();
        tab.querySelectorAll('[data-style]').forEach((b) => {
          const c = (b.dataset.category || '').trim(); if (c && !seen.has(c.toLowerCase())) seen.set(c.toLowerCase(), c);
        });
        if (seen.size < 2) { box.hidden = true; return; }
        const make = (key, text, on) => {
          const chip = document.createElement('button');
          chip.type = 'button'; chip.className = 'pss__chip'; chip.textContent = text; chip.dataset.cat = key;
          chip.setAttribute('aria-pressed', on ? 'true' : 'false');
          chip.addEventListener('click', () => { this.userInteract(); this.setCategory(tab, key); });
          box.appendChild(chip);
        };
        make('all', box.dataset.allLabel || 'All', true);
        seen.forEach((text, key) => make(key, text, false));
      }
 
      setCategory(tab, key) {
        tab.querySelectorAll('[data-chips] .pss__chip').forEach((c) => c.setAttribute('aria-pressed', c.dataset.cat === key ? 'true' : 'false'));
        tab.querySelectorAll('[data-style]').forEach((b) => {
          b.hidden = key !== 'all' && (b.dataset.category || '').trim().toLowerCase() !== key;
        });
        const cur = tab.querySelector('[data-style].is-on');
        const vis = this.galleryButtons(tab);
        if ((!cur || cur.hidden) && vis.length) this.activateStyle(vis[0]);
        else this.updateCount(tab);
      }
 
      updateNow(tab, btn) {
        const box = tab && tab.querySelector('[data-now]'); if (!box) return;
        btn = btn || tab.querySelector('[data-style].is-on');
        if (!btn) return;
        const name = (btn.querySelector('.pss__style-label') || {}).textContent || '';
        box.querySelector('[data-now-name]').textContent = name.trim();
        box.querySelector('[data-now-text]').textContent = btn.dataset.caption || '';
        if (!this.reduced) { box.classList.remove('is-bump'); void box.offsetWidth; box.classList.add('is-bump'); }
      }
 
      startPlay(btn) {
        this.playBtn = btn;
        btn.setAttribute('aria-pressed', 'true');
        const t = btn.querySelector('[data-play-text]'); if (t) t.textContent = btn.dataset.pauseLabel || 'Pause';
        this.playTimer = setInterval(() => this.step(1), 2200);
        this.step(1);
      }
 
      stopPlay() {
        if (!this.playTimer) return;
        clearInterval(this.playTimer); this.playTimer = null;
        const b = this.playBtn; if (!b) return;
        b.setAttribute('aria-pressed', 'false');
        const t = b.querySelector('[data-play-text]'); if (t) t.textContent = b.dataset.playLabel || 'Play';
      }
 
      step(dir) {
        const btns = this.galleryButtons(); if (!btns.length) return;
        const i = Math.max(0, btns.findIndex((b) => b.classList.contains('is-on')));
        this.activateStyle(btns[(i + dir + btns.length) % btns.length]);
      }
 
      shuffle() {
        const btns = this.galleryButtons(); if (btns.length < 2) return;
        const i = btns.findIndex((b) => b.classList.contains('is-on'));
        let j = i; while (j === i) j = Math.floor(Math.random() * btns.length);
        this.activateStyle(btns[j]);
      }
 
      updateCount(tab, btn) {
        if (!this.countEl || !tab) return;
        const btns = this.galleryButtons(tab);
        btn = btn || tab.querySelector('[data-style].is-on') || btns[0];
        if (!btn || btns.indexOf(btn) < 0) { this.countEl.textContent = ''; return; }
        const label = (btn.querySelector('.pss__style-label') || {}).textContent || '';
        this.countEl.textContent = label.trim() + ' \u00b7 ' + (btns.indexOf(btn) + 1) + ' of ' + btns.length;
      }
 
      celebrate() {
        if (this.reduced) return;
        const img = this.afterImg;
        if (img) { img.classList.remove('is-pop'); void img.offsetWidth; img.classList.add('is-pop'); }
        if (!this.burstEl) return;
        const cols = ['#FFD34D', '#FF6FA8', '#7FD3FF', '#9BE15D', '#C98BFF'];
        for (let k = 0; k < 12; k++) {
          const s = document.createElement('span'); s.className = 'pss__spark';
          const a = (k / 12) * Math.PI * 2 + Math.random() * .4, d = 90 + Math.random() * 90;
          s.style.setProperty('--dx', Math.cos(a) * d + 'px'); s.style.setProperty('--dy', Math.sin(a) * d + 'px');
          s.style.setProperty('--c', cols[k % cols.length]);
          this.burstEl.appendChild(s); setTimeout(() => s.remove(), 800);
        }
      }
 
      /* ---------- Tabs & themes ---------- */
      bindTabs() {
        this.tabs.forEach((tab, i) => {
          const head = tab.querySelector('[data-tab-head]');
          if (head) head.addEventListener('click', () => { this.userInteract(); this.activateTab(i); });
          tab.querySelectorAll('[data-style]').forEach((btn) => {
            btn.addEventListener('click', () => { this.userInteract(); this.activateStyle(btn); });
          });
        });
      }
 
      activateTab(i, styleBtn) {
        const tab = this.tabs[i];
        if (!tab) return;
        if (i !== this.activeIndex) {
          this.activeIndex = i;
          this.tabs.forEach((t, j) => {
            const on = j === i;
            t.classList.toggle('is-active', on);
            const head = t.querySelector('[data-tab-head]');
            const body = t.querySelector('.pss__tab-body');
            if (head) head.setAttribute('aria-expanded', on);
            if (body) body.inert = !on;
          });
          (this.switches || []).forEach((b, j) => b.setAttribute('aria-pressed', j === i ? 'true' : 'false'));
        }
        this.applyMode(tab);
        const btn = styleBtn || tab.querySelector('[data-style].is-on') || tab.querySelector('[data-style]');
        if (btn) this.activateStyle(btn);
        else if (tab.dataset.before) this.swap(this.beforeImg, tab.dataset.before, tab.dataset.beforeAlt);
      }
 
      activateStyle(btn) {
        const tab = btn.closest('[data-tab]');
        const i = this.tabs.indexOf(tab);
        if (i !== this.activeIndex) return this.activateTab(i, btn);
 
        const already = btn.classList.contains('is-on');
        tab.querySelectorAll('[data-style]').forEach((b) => {
          const on = b === btn;
          b.classList.toggle('is-on', on);
          b.setAttribute('aria-pressed', on);
        });
 
        const changedBefore = this.swap(this.beforeImg, btn.dataset.before, btn.dataset.beforeAlt);
        const changedAfter = this.swap(this.afterImg, btn.dataset.after, btn.dataset.afterAlt);
        this.centerInStrip(btn);
        if (tab.dataset.mode === 'gallery') {
          this.updateCount(tab, btn);
          this.updateNow(tab, btn);
          if (changedAfter || !already) this.celebrate();
        } else if ((changedBefore || changedAfter || !already) && this.reveal && !this.reduced) {
          this.animatePos(100, 50, 900);
        }
      }
 
      centerInStrip(btn) {
        const strip = btn && btn.parentElement;
        if (!strip || strip.scrollWidth <= strip.clientWidth + 2) return;
        const left = btn.offsetLeft - (strip.clientWidth - btn.offsetWidth) / 2;
        try { strip.scrollTo({ left, behavior: this.reduced ? 'auto' : 'smooth' }); } catch (_) { strip.scrollLeft = left; }
      }
 
      swap(img, src, alt) {
        if (!img || !src || img.dataset.src === src) return false;
        img.dataset.src = src;
        img.hidden = false;
        img.classList.add('is-fading');
        const pre = new Image();
        pre.src = src;
        const done = () => {
          if (img.dataset.src !== src) return; // a newer swap won
          img.src = src;
          img.removeAttribute('srcset');
          img.alt = alt || '';
          requestAnimationFrame(() => img.classList.remove('is-fading'));
        };
        (pre.decode ? pre.decode() : Promise.resolve()).then(done, done);
        return true;
      }
 
      /* ---------- Autoplay ---------- */
      setupAutoplay() {
        if (!this.autoplayMs || this.reduced || (window.Shopify && window.Shopify.designMode)) return;
        this.steps = [];
        this.tabs.forEach((t, i) => {
          const styles = Array.from(t.querySelectorAll('[data-style]'));
          if (styles.length) styles.forEach((b) => this.steps.push([i, b]));
          else this.steps.push([i, null]);
        });
        if (this.steps.length < 2) return;
        this.step = 0;
        this.io = new IntersectionObserver(([entry]) => { this.visible = entry.isIntersecting; this.tick(); }, { threshold: 0.35 });
        this.io.observe(this);
        this.addEventListener('mouseenter', () => { this.hover = true; this.tick(); });
        this.addEventListener('mouseleave', () => { this.hover = false; this.tick(); });
        this.addEventListener('focusin', () => { this.hover = true; this.tick(); });
        this.addEventListener('focusout', () => { this.hover = false; this.tick(); });
      }
 
      tick() {
        clearTimeout(this.timer);
        if (!this.steps || this.stopped || !this.visible || this.hover) return;
        this.timer = setTimeout(() => {
          this.step = (this.step + 1) % this.steps.length;
          const [i, btn] = this.steps[this.step];
          this.activateTab(i, btn);
          this.tick();
        }, this.autoplayMs);
      }
 
      userInteract() {
        this.stopPlay();
        this.stopped = true;
        clearTimeout(this.timer);
        cancelAnimationFrame(this.raf);
      }
 
      /* ---------- Theme editor ---------- */
      bindEditor() {
        this.onBlockSelect = (e) => {
          if (!this.contains(e.target)) return;
          this.userInteract();
          if (e.target.matches('[data-style]')) this.activateStyle(e.target);
          else if (e.target.matches('[data-tab]')) this.activateTab(this.tabs.indexOf(e.target));
        };
        document.addEventListener('shopify:block:select', this.onBlockSelect);
      }
    }
    customElements.define('photo-style-showcase', PhotoStyleShowcase);
  }

  } catch(e) { console.error(e); }
})();
})();
